import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import MultiProjectionField from 'modules/reports/components/Editor/Carcasa/FormFields/MultiProjectionField'
import { FieldSelectionType } from 'modules/reports/hooks/useReportTracking'
import { TYPES, UI_GROUPS } from 'modules/reports/lib/Constants'
import type { ReportEditorStore } from 'modules/reports/lib/Store'

interface Props {
  store: ReportEditorStore
}

const ScatterplotView = ({ store }: Props) => {
  const labelAbscissa = {
    text: i18n.t('custom_reports.fields.abscissa'),
  }

  const labelOrdinate = {
    text: i18n.t('custom_reports.fields.ordinate'),
  }

  return (
    <>
      <MultiProjectionField
        selectionType={FieldSelectionType.Data}
        store={store}
        uiGroup={UI_GROUPS.abscissa}
        excludeIdentifiers
        excludeTypes={[TYPES.cohort]}
        label={labelAbscissa}
      />

      <MultiProjectionField
        selectionType={FieldSelectionType.Data}
        store={store}
        uiGroup={UI_GROUPS.ordinate}
        excludeIdentifiers
        excludeTypes={[TYPES.cohort]}
        label={labelOrdinate}
      />
    </>
  )
}

export default ScatterplotView
